import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ScreenUsers: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="screen icon">
      {/* <title>screen icon</title> */}
      <path d="M96 64h448v160c24.62 0 47 9.625 64 25V49.63c0-27.38-21.5-49.63-48-49.63h-480c-26.5 0-48 22.25-48 49.63v199.4c17-15.38 39.38-25 64-25V64zM256.2 320c0 35.26 28.57 63.85 63.79 63.98C355.2 383.8 383.8 355.3 383.8 320S355.2 256.2 320 256C284.8 256.2 256.2 284.7 256.2 320zM343.8 416h-47.5C256.4 416 224 449.5 224 490.7C224 502.4 233.3 512 244.8 512h150.3C406.7 512 416 502.4 416 490.7C416 449.5 383.6 416 343.8 416zM567.8 416h-47.5C480.4 416 448 449.5 448 490.7C448 502.4 457.3 512 468.8 512h150.3C630.7 512 640 502.4 640 490.7C640 449.5 607.6 416 567.8 416zM480.2 320c0 35.26 28.57 63.85 63.79 63.98C579.2 383.8 607.8 355.3 607.8 320S579.2 256.2 544 256C508.8 256.2 480.2 284.7 480.2 320zM32.21 320c0 35.26 28.57 63.85 63.79 63.98C131.2 383.8 159.8 355.3 159.8 320S131.2 256.2 96 256C60.78 256.2 32.21 284.7 32.21 320zM119.8 416h-47.5C32.42 416 0 449.5 0 490.7C0 502.4 9.34 512 20.83 512h150.3C182.7 512 192 502.4 192 490.7C192 449.5 159.6 416 119.8 416z" />
    </svg>
  );
};

export default ScreenUsers;
